/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], function () {

	class DataSourcePanelColumnInsertionHelper  {
		constructor({ dashboardApi }) {
			this.dashboardApi = dashboardApi;

			this._initialize();
		}

		_initialize() {
			// FilterDock is going away. We should not depend upon the filterDocker feature.
			// TODO: Rewrite this logic in a centralized feature so it can be used in both
			// the filter UI and here.
			const canvas = this.dashboardApi.getCanvas();
			canvas.getFeature('filterDock').then(filterDock => this._filterDock = filterDock);
		}

		addToCanvas(payload) {
			if (payload.data && payload.data.utils && payload.data.utils.isValid()) {
				this.dashboardApi.addContentToCanvas(payload);
			}
		}

		_isLocalFilterSupported() {
			// It is assumed local filters are always supported,
			// however this may not be true - FilterContainerView._createNewFilterDocker
			// reads details.showTabDocks to determine whether to populate tabDock.
			// TODO: Review this logic and centralize to a common feature so it can be
			// used in both the filter UI code and here.
			return true;	//Probably wrong.
		}

		_isGlobalFilterSupported() {
			// TODO: Don't use filter dock to determine this value.
			return this._filterDock.isGlobalDockShown !== false;
		}

		_getPageContextType(dataType, usage) {
			if (usage === 'fact') {
				return 'range';
			}

			// usage is attribute: non numeric, tree, or date time filter
			var isDateType = dataType === 'date' || dataType === 'time' || dataType === 'datetime' || dataType === 'timestamp';
			return isDateType ? 'range' : 'tupleset';
		}

		_addToFilter(payload, scope) {
			const selectedColumns = payload.data.columns;
			const options = {
				scope,
				openViewOnLoad: (selectedColumns.length > 1) ? false : true
			};
			const canvas = this.dashboardApi.getCanvas();

			// loop through selected items and create filter for each
			for (let column of selectedColumns) {
				const metadataColumn = column.metadataColumn;
				if (this._getPageContextType(metadataColumn.getDataType(), metadataColumn.getType()) === 'range') {
					options.condition = {};
				} else {
					options.values = [];
				}
				canvas.getFilters().addFilter({
					sourceId: metadataColumn.getSourceId(),
					itemId: metadataColumn.getId()
				}, options);
			}
		}

		addToLocalFilter(payload) {
			if(this._isLocalFilterSupported()) {

				//TODO: Don't use FilterDock. Review this logic and centralize it in a common feature.
				return this._addToFilter(payload, this._filterDock.currentScope());
			}
		}

		addToGlobalFilter(payload) {
			if (this._isGlobalFilterSupported()) {
				return this._addToFilter(payload, null);
			}
		}
	}

	return DataSourcePanelColumnInsertionHelper;
});
